import { z } from "zod";

import { ActionSchema } from "../../../shared/domain/agents";

/**
 * CustomManifest tool actions — stored in AgentExternalTool.actions
 * when type = CUSTOM_MANIFEST. Array of ActionType objects, one per API endpoint.
 *
 * At runtime, the executor finds the matching action by operationId:
 *   (tool.actions as ActionType[]).find(a => a.operationId === data.action)
 *
 * parametersFields and bodyFields contain the field descriptors for each
 * action's query params and request body. Their item shapes vary per tool
 * and are defined by the tool creator in the marketplace UI.
 */
export const CustomManifestActionsSchema = z.array(ActionSchema);

export type CustomManifestActions = z.infer<typeof CustomManifestActionsSchema>;
